import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import ProductListingPageSidebar from "components/ProductListingPage/Sidebar";
import ProductList from "components/ProductList";
import ProductListingPageAction from "components/ProductListingPage/Actions";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import HotOffers from "components/HotOffers";
import {
  getHotOffersData,
  getFilterOptionList,
  getProductListByDepartment,
  getDepartmentTree,
  resetFilterSideBar,
  addOrAddAllProductToCart,
  getCartList
} from "redux/actions";
import "./reorder-department.scss";
import AdsSpaceSection from "./AdsSpaceSection";
import { getLocalStorageValue } from 'config/helper';

const ReorderDepartment = () => {
  const { departmentSlug } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const function_names = searchParams.get("function_names");
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");

  const { activePageNo, sortByValue, iftCheckedList, filterOptionList, fromCheckedList, pastOrderCheckedList } =
    useSelector(({ product }) => product);

  const sortByOptionList = filterOptionList.sort_by_section;
  const selectedSortByOption =
    sortByOptionList &&
    sortByOptionList.find((option) => option.sort_id === sortByValue);

  const sortBy = selectedSortByOption && selectedSortByOption.field_name;

  const ecomData = useSelector(
    ({ common }) => common.commonDetailsData.ecom_section.sub_department
  );

  const departmentDetails =
    ecomData && ecomData.find((ecom) => ecom.slug === departmentSlug);

  const {
    minPriceValue,
    maxPriceValue,
    departmentTree,
    productListByDepartmentTotalCount,
    categoryadsSection,
  } = useSelector(({ product }) => product);

  const [pageLimit, setPageLimit] = useState("20");

  const breadcrumbList = [
    { lable: "Department", link: "", searchTag: "" },
    {
      lable: "Re-Order",
      link: "",
      searchTag: "",
    },
  ];

  useEffect(() => {
    return () => {
      dispatch(resetFilterSideBar());
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : ""
    };
    dispatch(getFilterOptionList(body));
  }, [storeId, isUserLoggedIn]); // eslint-disable-line

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : ""
    };
    dispatch(getHotOffersData(body));
  }, [storeId, isUserLoggedIn]); // eslint-disable-line

  const iftCheckedListJoin = iftCheckedList.join("|");
  const fromCheckedListJoin = fromCheckedList.join("|");
  const pastOrderCheckedListJoin = pastOrderCheckedList.join("|");

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      PageNo: activePageNo,
      category_ids: departmentDetails && departmentDetails.category_ids,
      ift: iftCheckedListJoin,
      reorder_date: pastOrderCheckedListJoin,
      list_id: fromCheckedListJoin,
      limit: pageLimit,
      sort_by: sortBy || "",
      min_price: minPriceValue.toString(),
      max_price: maxPriceValue.toString(),
      funtional_text: "",
      funtional_level: "",
      function_names: function_names || "",
      recently_purchased: "1",
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : ""
    };
    dispatch(getProductListByDepartment(body));
  }, [
    dispatch,
    iftCheckedListJoin,
    fromCheckedListJoin,
    pastOrderCheckedListJoin,
    sortBy,
    pageLimit,
    departmentDetails,
    activePageNo,
    minPriceValue,
    maxPriceValue,
    storeId,
    function_names,
    clientId,
    memberNumber,
    userToken,
    isUserLoggedIn
  ]); // eslint-disable-line

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      search: "",
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : ""
    };
    !departmentTree.length && dispatch(getDepartmentTree(body));
  }, [storeId, isUserLoggedIn]); // eslint-disable-line


  const handleAddAllItemToCart = () => {
    if (!isUserLoggedIn) {
      navigate("/login");
    }

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      AppName: isUserLoggedIn ? "shop" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      is_reorder: 1,
      items_data: productList.map((product) => {
        return { product_id: product.product_id, qty: product.qty };
      }),
    };
    isUserLoggedIn &&
      dispatch(addOrAddAllProductToCart(body)).then((res) => {
        const body = {
          RSAClientId: clientId,
          ClientStoreId: +storeId || 1,
          AppName: "shop",
          member_number: memberNumber,
          user_token: userToken,
          Version: "1",
          DeviceType: "web",
        };
        isUserLoggedIn && dispatch(getCartList(body));
      });
  };

  const hotOffersData = useSelector(({ hotOffers }) => hotOffers.hotOffersData);
  const hotOfferTitle = hotOffersData.title;
  const adverstiseSectionData = hotOffersData.adverstise_section;

  // For sort by filter

  const sortByOption =
    sortByOptionList &&
    sortByOptionList
      .filter((option) => option.is_visible === "1")
      .map((limit) => {
        return {
          title: limit.title,
          value: limit.sort_id,
        };
      });

  // For show per page

  const listLimitOptionList = filterOptionList.list_limit_section;

  const listLimitOption =
    listLimitOptionList &&
    listLimitOptionList
      .filter((option) => option.is_visible === "1")
      .map((limit) => {
        return {
          title: limit.title,
          value: limit.title,
        };
      });

  const productList = useSelector(
    ({ product }) => product.productListByDepartment
  );

  const productListByDepartmentTotalPages = useSelector(
    ({ product }) => product.productListByDepartmentTotalPages
  );

  const priceSection = useSelector(
    ({ product }) => product.filterOptionList.price_section
  );

  const updatedDepartmentTree = departmentTree
    ? departmentTree
      .map((department) => {
        return {
          ...department,
          text: department.name,
        };
      })
    : [];


  const iftOptionList = useSelector(
    ({ product }) => product.filterOptionList.ift_section
  );


  return (
    <>


      <BreadcrumbDetailed
        breadcrumbList={breadcrumbList}
        title={"Re-Order"}
      />


      <div className="container">
        <div className="reorder-page-wrapper">
          <div className="listing-page-wrapper-items">
            <ProductListingPageSidebar
              isShowReorder={true}
              priceSection={priceSection}
              departmentTree={updatedDepartmentTree}
              otherDepartmentTree={[]}
              iftOptionList={iftOptionList}
              maxPriceValue={maxPriceValue}
              minPriceValue={minPriceValue}
              redirectBaseUrl="department"
            />
          </div>
          <div className="listing-page-wrapper-items">
            <AdsSpaceSection adsImage={categoryadsSection} />

            <ProductListingPageAction
              isShowReorder={true}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              listLimitOption={listLimitOption}
              sortByOption={sortByOption}
              productListByDepartmentTotalCount={
                productListByDepartmentTotalCount
              }
              priceSection={priceSection}
              departmentTree={updatedDepartmentTree}
              otherDepartmentTree={[]}
              iftOptionList={iftOptionList}
              maxPriceValue={maxPriceValue}
              minPriceValue={minPriceValue}
              redirectBaseUrl="department"
              productList={productList}
              handleClickAddAllToCart={handleAddAllItemToCart}
            />
            <ProductList
              activePageNo={activePageNo}
              productList={productList}
              productListByDepartmentTotalPages={
                productListByDepartmentTotalPages
              }
            />
          </div>
        </div>
        <HotOffers
          title={hotOfferTitle}
          adverstiseSectionData={adverstiseSectionData}
        />
      </div>
    </>
  );
};
export default ReorderDepartment;
